/** @typedef {{ id: string, code: string, label: string, category?: string|null, sort_order?: number }} MilestoneNameOption */

export function normalizeMilestoneNameOptions(rows) {
  return (rows || [])
    .slice()
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.label.localeCompare(b.label, 'fr'));
}

export function requiresMilestoneNameSelection(options) {
  return (options?.length ?? 0) > 1;
}

export function getMilestoneCurrentName(milestone) {
  return String(milestone?.name ?? milestone?.milestone_name ?? '').trim();
}

/** Choix runtime encore requis (plusieurs options, nom actuel hors liste). */
export function isMilestoneNameChoicePending(milestone, options) {
  if (!requiresMilestoneNameSelection(options)) return false;
  const current = getMilestoneCurrentName(milestone);
  if (!current) return true;
  return !options.some((o) => o.label === current);
}

export function resolveMilestoneDisplayName(milestone, options, genericLabel) {
  const current = getMilestoneCurrentName(milestone);
  if (options?.length && options.some((o) => o.label === current)) return current;
  if (genericLabel?.trim()) return genericLabel.trim();
  if (options?.length === 1) return options[0].label;
  return current || '—';
}

export function resolveInitialMilestoneName(templateGenericName, options) {
  const generic = String(templateGenericName ?? '').trim();
  if (!options?.length) return generic;
  if (options.length === 1) return options[0].label;
  return generic;
}

export function assertValidMilestoneNameChoice(label, options) {
  const trimmed = String(label ?? '').trim();
  if (!options?.length) return trimmed;
  if (options.length === 1) return options[0].label;
  const match = options.find((o) => o.label === trimmed);
  if (!match) {
    throw new Error('Choix de jalon invalide.');
  }
  return match.label;
}

export function optionIdsFromSelection(selectedIds, catalog) {
  const set = new Set(selectedIds || []);
  return (catalog || [])
    .filter((o) => set.has(o.id))
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    .map((o) => o.id);
}

/** Styles segmentés par catégorie (fallback générique). */
export function segmentClassForNameOption(option) {
  if (option?.category === 'cut_mode') {
    if (option.code === 'laser') {
      return 'bg-primary text-primary-foreground border-primary hover:bg-primary/90';
    }
    if (option.code === 'manuel') {
      return 'bg-slate-600 text-white border-slate-600 hover:bg-slate-700';
    }
  }
  return 'bg-muted text-foreground border-border hover:bg-muted/80';
}
